import React, { useEffect, useState } from 'react';
import {  Row, Col, Form, Modal, Input, Select,Alert} from 'antd';
// import { useHistory } from 'react-router';
import axios from 'axios';
import config from "../../config.json";
 import ErrorPage from './../error-views/errorPage'
const { Option } = Select;

const TableData = ({ onCancel, item,labelEdit }) => {
     const cl = localStorage.getItem("CL");
    const token = localStorage.getItem("token");
     const [visible,setVisible]=useState(labelEdit)
     // eslint-disable-next-line 
    const [apiError, setapiError] = useState(null);
    const [Loading, setLoading] = useState(true);
	const [buttonLoading, setbuttonLoading] = useState(false);
    const [alert, setAlert] = useState(false)

    const [form] = Form.useForm();
   
    useEffect(() => {
        async function fetchData() {
            let initialFormValues = {
                 'token': item.token_no,
                 'label' : '',
                 'sheet' : '',
                 'Date' : item.Date,
                 'status' : 'Done'
            }
            form.setFieldsValue(initialFormValues);
        }
        fetchData();
        // eslint-disable-next-line 
      }, [item]);


    const handleOk = () => {
        let f1 = form.getFieldsValue();
        let data = {
        'labelNo' :f1.label,
        'sheetNo' : f1.sheet,
        'tokenNo' : f1.token,
        'date': f1.Date,
        'status': "Done"
               
        }
		setAlert(true)
		setbuttonLoading(true);
        let url = config.OMsubmitdata;
      axios.post(url, data, { headers: { 'Authorization': token } })
        .then(resp => {
            if (resp.data.status === "error") setapiError(resp.data);
              else{
                setAlert(true)
				setbuttonLoading(false);
                // alert("Updated Successfully");
              window.location='/omCrPortal/app/EnlishLabel';
              }
        }, err => {
            let obj={"status":"error","message":"Network Error"};
            if(err.response) setapiError(err.response);
            else setapiError(obj);
        });

    }

    return (
    apiError?<ErrorPage details={apiError}/>:
        
        <Modal title="Change Label Form"
             visible={visible}
            onOk={handleOk}
            okLoading={buttonLoading}
            okButtonProps={buttonLoading?{ disabled:  buttonLoading  }:""}
            onCancel={onCancel}
            cancelButtonProps={{ hidden: true }}
            okText="Save"
        >
            <Form
                form={form}
                layout="vertical"
                name="new-event"
                preserve={false}
            >
                          {alert===true ? <Alert 
                            message="Success" 
                            description="Updated Successfully." 
                            type="success" 
                            showIcon 
                            details={alert} 
                            />  
                            : 
                                ""} 
                <Row gutter="16">
                    <Col span={12} >
                        <Form.Item name="token" label="Token No">
                            <Input autoComplete="off" disabled/>
                        </Form.Item>
                    </Col>

                    <Col span={12} >
                    <Form.Item name="Date" label="Date">
                            <Input autoComplete="off" disabled />
                        </Form.Item>
                      
                    </Col>
                </Row>

                 <Row gutter="16">
                    <Col span={12} >
                       
                        <Form.Item name="label" label="Label">
                            <Input autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Form.Item name="sheet" label="Sheet No">
                            <Input autoComplete="off" />
                        </Form.Item>
                    <Col span={12} >
                      
                    </Col>
                </Row>

            
            </Form>

        </Modal>
    )
}
export default TableData